import { useState } from "react";
import { useNavigate } from "react-router";
import AuthorshipsTable from "../../../components/AuthorshipsTable";
import RoundedCard from "../../../components/RoundedCard";
import { useAuthorships } from "@/hooks/useAuthorships";
import AuthorshipCreateDialog from "./AuthorshipCreateDialog";

type AuthorshipsDocumentTabProps = {
  detailPathPrefix?: string;
  description: string | null;
  reported?: boolean | null;
  showStatusColumn?: boolean;
  title: string;
};

const AUTHORSHIPS_PAGE_SIZE = 10;

const AuthorshipsDocumentTab = ({
  detailPathPrefix = "",
  description,
  reported,
  showStatusColumn = true,
  title,
}: AuthorshipsDocumentTabProps) => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const {
    data: response,
    isError,
    isFetching,
    isLoading,
  } = useAuthorships({
    page,
    page_size: AUTHORSHIPS_PAGE_SIZE,
    reported,
  });

  const handleAuthorshipClick = (authorshipId: string) => {
    void navigate(`${detailPathPrefix}forfatterskab/${authorshipId}`);
  };

  return (
    <RoundedCard
      bodyClassName="p-0 mt-3"
      header={title}
      description={description}
      action={<AuthorshipCreateDialog />}
    >
      <AuthorshipsTable
        authorships={response?.items ?? []}
        isError={isError}
        isLoading={isLoading}
        onAuthorshipClick={handleAuthorshipClick}
        showStatusColumn={showStatusColumn}
        pagination={
          response
            ? {
                isDisabled: isFetching,
                onPageChange: setPage,
                page: response.page,
                total: response.total,
                totalPages: response.totalPages,
              }
            : undefined
        }
      />
    </RoundedCard>
  );
};

export default AuthorshipsDocumentTab;
